import { cn } from '../../lib/cn';

interface HankoProps {
  text: string;
  size?: number;
  className?: string;
  animate?: boolean;
}

/**
 * Hanko (印章) stamp rendered as inline SVG. The seal-script style is
 * approximated with a circular Noto Serif JP glyph in the accent-red
 * traditional vermilion (#C8102E). Adds the hanko-stamp keyframe when
 * `animate` is true — used when an approver applies their stamp.
 */
export function HankoStamp({ text, size = 56, className, animate }: HankoProps) {
  const r = size / 2;
  // Truncate name to max 2-3 chars; if longer, take last 2 (family-name 慣習).
  const display = text.length > 2 ? text.slice(-2) : text;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={cn(animate ? 'hanko-stamp' : '', className)}
      aria-label={`Hanko: ${text}`}
    >
      <circle
        cx={r}
        cy={r}
        r={r - 3}
        fill="none"
        stroke="#C8102E"
        strokeWidth={3}
      />
      <text
        x={r}
        y={r + size * 0.13}
        textAnchor="middle"
        fontFamily="Noto Serif JP, serif"
        fontWeight={700}
        fontSize={size * 0.4}
        fill="#C8102E"
      >
        {display}
      </text>
    </svg>
  );
}
